import { useState } from 'react';
import {
  deliveryByYear,
  deliveryYearSalesTotals,
  deliveryYears,
  type DeliveryYear,
} from '../DeliveryList';

function DeliveryResultsPage() {
  const [year, setYear] = useState<DeliveryYear>(2025);
  const rows = deliveryByYear[year];
  const yearTotalDisplay =
    deliveryYearSalesTotals.find((e) => e.year === year)?.총매출 ?? '—';
  const show현장명 = rows.some(
    (r) => r.현장명 !== undefined && String(r.현장명).trim() !== '',
  );

  return (
    <section className="page delivery-page">
      <h1 className="page-title">납품실적</h1>
      <div className="delivery-layout">
        <nav className="delivery-nav" aria-label="연도별 실적">
          <ul className="delivery-nav__list">
            {deliveryYears.map((y) => (
              <li key={y}>
                <button
                  type="button"
                  className={
                    y === year
                      ? 'delivery-nav__btn delivery-nav__btn--active'
                      : 'delivery-nav__btn'
                  }
                  onClick={() => setYear(y)}
                  aria-current={y === year ? 'true' : undefined}
                >
                  {y}년 실적
                </button>
              </li>
            ))}
          </ul>
        </nav>
        <div className="delivery-panel">
          <h2 className="delivery-panel__heading visually-hidden">
            {year}년 납품실적
          </h2>
          <div className="delivery-panel__content">
            <div className="delivery-sheet">
              <table
                className="delivery-summary-table"
                aria-label={`${year}년 총 매출`}
                aria-live="polite"
              >
                <tbody>
                  <tr>
                    <td
                      className="delivery-summary-table__label"
                      colSpan={show현장명 ? 4 : 3}
                    >
                      총 매출
                    </td>
                    <td className="delivery-summary-table__amount">
                      {yearTotalDisplay}
                    </td>
                  </tr>
                </tbody>
              </table>
              <div className="delivery-table-wrap">
                <table className="delivery-table">
                  <caption className="visually-hidden">
                    {year}년 납품실적 — NO, 발주처, 품목
                    {show현장명 ? ', 현장명' : ''}, 금액
                  </caption>
                  <thead>
                    <tr>
                      <th scope="col">NO</th>
                      <th scope="col">발주처</th>
                      <th scope="col">품목</th>
                      {show현장명 ? <th scope="col">현장명</th> : null}
                      <th scope="col" className="delivery-table__amount">
                        금액
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {rows.map((row) => (
                      <tr key={`${year}-${row.no}`}>
                        <td>{row.no}</td>
                        <td>{row.발주처}</td>
                        <td>{row.품목}</td>
                        {show현장명 ? (
                          <td>{row.현장명?.trim() ? row.현장명 : '—'}</td>
                        ) : null}
                        <td className="delivery-table__amount">{row.금액}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default DeliveryResultsPage;
